import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "mise_session_token";
export const getSessionToken = () => {
  try { return localStorage.getItem(TOKEN_KEY) || ""; } catch { return ""; }
};
export const setSessionToken = (t) => {
  try {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {}
};

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach token from localStorage as Authorization header — fallback when
// cookies are stripped (Safari ITP, PWAs, mobile WebView).
api.interceptors.request.use((cfg) => {
  const t = getSessionToken();
  if (t) {
    cfg.headers = cfg.headers || {};
    if (!cfg.headers.Authorization) {
      cfg.headers.Authorization = `Bearer ${t}`;
    }
  }
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      // Token rejected by server — clear stash so we don't loop.
      setSessionToken("");
    }
    return Promise.reject(err);
  }
);
